import React, { useEffect, useMemo, useState } from "react";
import {
    AdvSeparator,
    Backdrop,
    Button,
    CopyToClipboard,
    DualIcon,
    InfoTextAdv,
    LogoLoader,
    showToast,
    PageHeader,
    NewTab,
    PageTitle,
    SmartTooltip,
    StatusTags,
    Modal,
    DocumentViewerATS
} from "../../../../../components";
import Resume from "../AllApplicantsViewTabs/Resume";
import PersonalDetails from "../AllApplicantsViewTabs/PersonalDetails";
import JobApplied from "../AllApplicantsViewTabs/JobApplied";
import Notes from "../AllApplicantsViewTabs/Notes";
import Skills from "../AllApplicantsViewTabs/Skills";
import WorkExperience from "../AllApplicantsViewTabs/WorkExperience";
import EmailMerges from "../AllApplicantsViewTabs/EmailMerges";
import ApplicantEmailModal from "./ApplicantDetailsModals/ApplicantEmailModal";
import ApplicantNotesModal from "./ApplicantDetailsModals/ApplicantNotesModal";
import ApplicantSubmitJobModal from "./ApplicantDetailsModals/ApplicantSubmitJobModal";
import { Link, useLocation, useParams } from "react-router-dom";
import { getApplicant } from "../../../../../redux/slices/recruitmentSourcing/SourcingApi";
import { addCandidateNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateAllSourceNotes } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { updateAllOtherSourceNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { updateApplicantNotes, updateApplicantWithNotes } from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";
import { formatPhoneNumberLength, formatWords2 } from "../../../../../utils/stringUtils";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { hasContent } from "../../../../../utils/common";

const ResumeViewerApplicant = (isOpen, onClose) => {
    // const applicantId = localStorage.getItem("applicantId") || "{}"
    // const keywords = JSON.parse(localStorage.getItem("keywords")) || "{}"
    const { applicantId } = useParams();
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const keywordsParam = queryParams.get("keywords");
    let keywords = [];
    try {
        keywords = keywordsParam
            ? JSON.parse(decodeURIComponent(keywordsParam))
            : [];
    } catch (error) {
        keywords = [];
    }
    //console.log(applicantId,keywords)
    const { user } = useSelector((state) => state?.auth);
    // const data = {
    //   Mobile: "+1323432490",
    //   "Job Title": "Frontend Developer",
    //   Location: "youngstan-OH-US",
    //   "Work Authorization": "--",
    //   "Experience(Years)": "10",
    //   Email: "dmosure12@gmail.com",
    // };
    const [applicantData, setApplicantData] = useState(null);
    const [emailModal, setEmailModal] = useState(false);
    const [notesModal, setNotesModal] = useState(false);
    const [notes, setCandidateNotes] = useState("");
    const [viewModal, setViewModal] = useState(false);
    const [awsUrl, setAwsUrl] = useState("");
    const [submitJobModal, setSubmitJobModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [awsurlloading, setawsurlLoading] = useState(false)
    const [awsHtmlResume, setAwsHtmlResume] = useState("");
    const dispatch = useDispatch();
    const [notesRefreshKey, setNotesRefreshKey] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const htmlFormat =  applicantData?.resumes?.at(-1)?.files?.at(-1)?.html || applicantData?.htmlResume || "Resume not available";
    
    const viewMenus = [
        {
            title: "Resume",
            page: <Resume candidate={applicantData} source={2} keywords={keywords || []} />,
            //   page: <Resume applicant={selectedApplicant} />,
            type: "main",
        },

        {
            title: "Personal Details",
            //   page: <PersonalDetails applicant={selectedApplicant} />,
            page: <PersonalDetails applicant={applicantData} />,
            type: "main",
        },
        {
            title: "Job Applied",
            page: <JobApplied data={applicantData}/>,
            type: "main",
        },
        {
            title: "Notes",
            //   page: <Notes applicant={selectedApplicant} />,
            page: <Notes applicantId={applicantData?.uiid} refreshKey={notesRefreshKey} openNotesModal={() => setNotesModal(true)} />,
            type: "main",
        },
        {
            title: "Skills",
            page: <Skills applicant={applicantData} />,
            type: "main",
        },
        {
            title: "Work Experience",
            page: <WorkExperience applicant={applicantData} />,
            type: "main",
        },
        {
            title: "Email Merges",
            page: <EmailMerges />,
            type: "main",
        },
    ];
    const data = {
        "Mobile": applicantData?.mobile?.primary
            ? `${applicantData?.mobile?.primary?.code} ${formatPhoneNumberLength(applicantData?.mobile?.primary?.code, applicantData?.mobile?.primary?.number)}`
            : "—",
        "Job Title": formatWords2(applicantData?.jobTitle || "—"),
        "Location": formatWords2(applicantData?.location?.city || "—"),
        "Work Authorization": formatWords2(applicantData?.workAuth || "—"),
        "Experience (Years)": applicantData?.exp
            ? `${applicantData?.exp?.year}.${applicantData?.exp?.mon}`
            : "—",
        "Email": applicantData?.email?.primary?.email || applicantData?.email?.primary || "—",
    };
    const handleClose = () => {
        setApplicantData(null);
        onClose();
    };

    //download
    const resumeLink = applicantData?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
    const resumeName =
        `${applicantData?.firstName} ${applicantData?.middleName} ${applicantData?.lastName}` ?? "resume";
    const resumePathName =
        applicantData?.resumes?.at(-1)?.files?.at(-1)?.name ?? "Resume.docx";
    const notesTabIndex = useMemo(
        () => viewMenus.findIndex((tab) => tab.title === "Notes"),
        [viewMenus]
    );
    const handleAddNotes = async (jobPost, priority) => {
        try {
            const res = await addCandidateNotes({
                coll: "Note",
                postActions: ["updateSource"],
                payload: {
                    addedBy: user?.data?.uiid,
                    candidateId: applicantData?.uiid,
                    note: notes,
                    source: 2,
                    ...(jobPost != null && { jobPostId: jobPost }),
                    ...(priority != null && { priority })
                },
            });
            if (res?.data) {
                setNotesModal(false);
                showToast("Notes added successfully.", "success", 2000);
                setCandidateNotes("");
                const data = res?.data?.data || {}
                // console.log(data)
                dispatch(updateAllSourceNotes({ applicantId: data.candidateId, newNoteUiid: data.uiid , uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn}))
                dispatch(updateAllOtherSourceNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid, uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn }))
                dispatch(updateApplicantNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid , uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn}))
                dispatch(
                    updateApplicantWithNotes({
                        applicantId: data?.candidateId,
                        uiid: data?.uiid,
                        note: data?.note,
                        addedBy: data?.addedBy,
                        addedOn: data?.addedOn
                    })
                );
                setNotesRefreshKey(prev => prev + 1);
                if (notesTabIndex !== -1) {
                    setActiveTab(notesTabIndex);
                }
            }
        } catch (error) {
            showToast("Error adding notes.", "error", 2000)
            console.error("Error adding notes:", error);
        } finally {
        }
    };

    const handleDownloadResume = async (response) => {
        try {
            // ---------- REPLACE FROM HERE ----------
            // if response is a URL string, just open it directly for download
            if (typeof response === "string" && response.startsWith("http")) {
                const link = document.createElement("a");
                link.href = response;
                // optional: set filename — browsers often ignore cross-origin downloads for filename
                link.download = resumeName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                showToast("Download successful.", "success", 2000);
                return; // done
            }
            // ---------- TO HERE ----------

            // existing fallback for Blobs/ArrayBuffers (leave as-is)
            let blob = response;
            if (response instanceof ArrayBuffer) blob = new Blob([response]);
            //console.log(blob);
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = resumeName || "resume.docx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
            showToast("Download successful.", "success", 2000);
        } catch (error) {
            showToast("Download unsuccessful.", "error", 2000);
            console.error(
                "Error triggering download:",
                error && error.message ? error.message : error
            );
        }
    };

    function extractS3Key(url) {
        return url.replace(/^https?:\/\/[^/]+\//, '');
    }

    const getCandidateResume = async () => {
        const fileExtension = resumePathName?.split('.').pop();
        const query = new URLSearchParams({
            key: extractS3Key(resumeLink),
            fileName: `${resumeName}.${fileExtension}`,
            coll: "Candidate",
        }).toString();

        const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
        try {
            const response = await axiosRequest({ method: "GET", url })

            if (!response?.success) {
                showToast("Download unsuccessful.", "error");
            }
            const data = response?.data?.data?.url || "";
            handleDownloadResume(data);

        } catch (err) {
            showToast("Download unsuccessful.", "error");
            console.error("Error fetching data:", err);
        }
    };
    //view Resume
    const viewResume = async () => {
        const query = new URLSearchParams({
            key: extractS3Key(resumeLink),
            // fileName: resumePathName,
            coll: "Candidate",
            html: true
        }).toString();
        const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
        setawsurlLoading(true)
        try {
            setAwsUrl("");
            setAwsHtmlResume("")
            const response = await axiosRequest({ method: "GET", url })
            const s3Key = response?.data?.data?.url || "";
            setAwsUrl(s3Key);
            setAwsHtmlResume(response?.data?.data?.htmlContent || "");
            setawsurlLoading(false)
        } catch (err) {
            setawsurlLoading(false)
        } finally {
            setawsurlLoading(false)
        }
    };

    const fetchApplicant = async () => {
        if (!isOpen) return;
        if (!applicantId) {
            setApplicantData(null);
            return;
        }
        try {

            setLoading(true);
            const res = await getApplicant({
                fil: JSON.stringify({
                    uiid: { type: "NONE", value: applicantId },
                }),
                coll: "Candidate",
                ref: "Resume",
                extret: "uiid firstName",
            });

            if (res?.data?.data) {
                setApplicantData(res.data.data);
            } else {
                showToast("No applicant details found", "warning");
            }
        } catch (err) {
            console.error(err);
            showToast("Failed to fetch applicant details", "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchApplicant();
    }, [applicantId, isOpen]);
    // if (loading) {
    //     return (
    //         <Drawer isOpen={isOpen} onClose={onClose} width="w-5xl" title="">
    //             <div className="p-10 text-center text-gray-500">Loading applicant details...</div>
    //         </Drawer>
    //     );
    // }



    return (
        <div className="min-h-full flex bg-gray-100">
            <div className="flex-1  flex flex-col bg-white max-w-6xl w-full mx-auto px-4 ">

                <div className="shadow-md !bg-[#fffcfa] rounded-lg p-3 mx-3 my-1">
                    <PageHeader
                        Section={
                            <div className="flex items-center gap-4">
                                <div className="flex flex-col items-start">
                                    <div className="text-primary mb-0.5">
                                        <PageTitle
                                            // title={
                                            //   // getCurrentApplicantPersonalDetails()["First Name"] +
                                            //   // " " +
                                            //   // getCurrentApplicantPersonalDetails()["Last Name"]
                                            //   "New Name"
                                            // }
                                            title={
                                              formatWords2(applicantData
                                                    ? applicantData?.applicantName ||
                                                    [applicantData?.firstName, applicantData?.middleName, applicantData?.lastName]
                                                        .filter(Boolean) // removes undefined, null, "", etc.
                                                        .join(" ") || "-"
                                                    : "-")
                                            }
                                            tag="h6"
                                        />
                                    </div>
                                    <div className="text-gray-400 font-[500] text-xs">
                                        <PageTitle
                                            // title={
                                            //   "New Role"
                                            //   // getCurrentApplicantJobTitle()
                                            // }
                                            title={formatWords2(applicantData ? applicantData?.jobTitle : "-")}
                                            tag="p"
                                        />
                                    </div>
                                </div>
                                <StatusTags icon />
                            </div>
                        }
                        RightSection={
                            <div className="flex item-center gap-3">
                                <SmartTooltip
                                    description={"Call"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <Button
                                        color="black"
                                        type="icon"
                                        icon={"phone"}
                                        variant="text"
                                        size="sm"
                                    />
                                </SmartTooltip>
                                <SmartTooltip
                                    description={"Download"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <Button
                                        color="black"
                                        type="icon"
                                        icon={"vertical_align_bottom"}
                                        disabled={resumeLink ? false : true}
                                        onClick={getCandidateResume}
                                        variant="text"
                                        size="sm"
                                    />
                                </SmartTooltip>
                                <Link
                                    to="/resumeviewerapplicant"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-info-400 flex items-center gap-.5"
                                >
                                    <SmartTooltip
                                        description={"Open New Tab"}
                                        tooltipPosition={"bottom"}
                                        noicon
                                    >
                                        <Button
                                            color="black"
                                            type="icon"
                                            disabled={true}
                                            icon={"open_in_new"}
                                            variant="text"
                                            size="sm"
                                        />
                                    </SmartTooltip>
                                </Link>
                                <SmartTooltip
                                    description={"View Resume"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <Button
                                        color="black"
                                        type="icon"
                                        disabled={resumeLink ? false : true}
                                        onClick={async () => {
                                            setViewModal(true);
                                            await viewResume();
                                        }}
                                        icon={"visibility"}
                                        variant="text"
                                        size="sm"
                                    />
                                </SmartTooltip>
                                <SmartTooltip
                                    description={"Email"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <Button
                                        color="black"
                                        type="icon"
                                        icon={"mail"}
                                        disabled={applicantData ? false : true}
                                        variant="text"
                                        size="sm"
                                        onClick={() => setEmailModal(true)}
                                    />
                                </SmartTooltip>
                                <SmartTooltip
                                    description={"Note"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <DualIcon
                                        iconColor={"black"}
                                        badgeIconColor="bg-black"
                                        disabled={applicantData ? false : true}
                                        size="xs"
                                        // onClick={() => setNotesModal(true)}
                                        onClick={() => {
                                            if (notesTabIndex !== -1) {
                                                setActiveTab(notesTabIndex); // changed as per chandan sir discussion 13-01-2026
                                            }
                                        }}
                                    />
                                </SmartTooltip>
                                <SmartTooltip
                                    description={"Submit Job"}
                                    tooltipPosition={"bottom"}
                                    noicon
                                >
                                    <DualIcon
                                        size="xs"
                                        icon="article"
                                        badgeIcon="visibility"
                                        disabled={applicantData ? false : true}
                                        iconColor="black"
                                        dotPosition="bottom-right"
                                        badgeIconColor="text-black"
                                        onClick={() => setSubmitJobModal(true)}
                                    />
                                </SmartTooltip>
                            </div>
                        }
                    // RightSection={Array.from({ length: 11 }, (_, i) => (
                    //   <span className="material-symbols-outlined mr-3">
                    //     vertical_align_bottom
                    //   </span>
                    // ))}
                    />

                    <div className="px-8 inner-section shadow-xl rounded-lg py-5 flex my-3">
                        <div className="flex flex-1 w-full">
                            <AdvSeparator gap="gap-6" className="gap-y-6 overflow-hidden">
                                {Object.keys(
                                    data
                                    //   getCurrentApplicantContactDetailsForHeader(source)
                                ).map((key, index) => {
                                    return (
                                        <>
                                            <InfoTextAdv
                                                key={index}
                                                title={key}
                                                titleProps={{ className: "!text-black" }}
                                                value={
                                                    <div className="w-full">
                                                        <div className=" text-black font-medium">
                                                            {key === "Email" ? (
                                                                <div className={"flex items-center gap-0.5 "}>
                                                                    <h6 className="line-clamp-1">
                                                                        {
                                                                            //   getCurrentApplicantContactDetailsForHeader(
                                                                            //     source
                                                                            //   )[key]
                                                                            data[key]
                                                                        }
                                                                    </h6>
                                                                    <CopyToClipboard
                                                                        content={
                                                                            //   getCurrentApplicantContactDetailsForHeader(
                                                                            //     source
                                                                            //   )[key]
                                                                            data[key]
                                                                        }
                                                                        title={data[key]}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <h6 className="line-clamp-1">
                                                                    {
                                                                        // getCurrentApplicantContactDetailsForHeader(
                                                                        //   source
                                                                        // )[key]
                                                                        data[key]
                                                                    }
                                                                </h6>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        </>
                                    );
                                })}
                            </AdvSeparator>
                        </div>
                    </div>
                </div>
                <div className="flex-1 flex flex-col overflow-hidden">
                    <NewTab
                        tabs={viewMenus}
                        color="gray"
                        variant="text"
                        activeVariant="text"
                        onTabChange={(index) => setActiveTab(index)}
                        defaultTab={activeTab}
                        key={activeTab} 
                    />
                </div>

                <ApplicantEmailModal
                    isOpen={emailModal}
                    onClose={() => setEmailModal(false)}
                />
                <ApplicantNotesModal
                    value={notes}
                    onChange={(e) => {
                        const val = e?.target?.value ?? e;
                        setCandidateNotes(val);
                    }}
                    onClick={async (jobPost, priority) => {
                        await handleAddNotes(jobPost, priority);
                    }}
                    isOpen={notesModal}
                    onClose={() => {
                        setNotesModal(false);
                        setCandidateNotes("");
                    }}
                />
                <ApplicantSubmitJobModal
                    isOpen={submitJobModal}
                    onClose={() => setSubmitJobModal(false)}
                    applicant={applicantData}
                />
                <Modal
                    width="max-w-6xl"
                    title={formatWords2(resumeName || "Resume Details")}
                    isOpen={viewModal}
                    onClose={() => setViewModal(false)}
                >
                    <DocumentViewerATS AwsResumeUrl={awsUrl || ""} urlLoading={awsurlloading} htmlFormat={hasContent(awsHtmlResume) ? awsHtmlResume : htmlFormat} />
                </Modal>
                <Backdrop isOpen={loading} zIndex={51}>
                    <LogoLoader />
                </Backdrop>
            </div>
        </div>
    );
};
// const ResumeViewerApplicant = () => {
// return(
//     <div>
//         <h1>hello</h1>
//     </div>
// )
// }
export default ResumeViewerApplicant;
